module.exports = __webpack_public_path__ + "static/event10-4e9da73f980b62c65f7fda951f6404a3.jpeg";